import React, { useState } from 'react';
import { Bot, TContact, termToContact } from "../bot-loaders";
import { Loading } from '../components/Loading';
import { Column, Table } from '../table/Table';



export  function TermToContactList({bot}:{bot:Bot}){
    const [searchTerm, setSearchTerm] = useState("")
    const [input, setInput] = useState("")
    const [loading, setLoading] = useState(false)
    const [contacts, setContacts] = useState<TContact[]>(null);
    
    async function doSearch(){
            if(input == ""){
                setContacts(null);
                return;
            }
            if(loading) return;
            setLoading(true);
            setSearchTerm(input);
            try {
                const list = await termToContact(bot, input);
                setContacts(list);
            } catch {
                setContacts(null);
            }

            setLoading(false);
    }

    return <>
        <div className='mb-2 d-flex' style={{maxWidth:"450px"}}>
            <input className='form-control me-2' value={input} onChange={(e) => setInput(e.target.value)} enterKeyHint='search' onKeyUp={(e) => {if(e.key == "Enter") doSearch()}} />
            <button className='btn btn-primary' onClick={doSearch}><i className='fa fa-search'></i></button>
        </div>
        <SearchResult loading={loading} contacts={contacts} searchTerm={searchTerm} />
    </>
    
}

function SearchResult({loading, contacts, searchTerm}:{loading:boolean, contacts:TContact[], searchTerm: string}){
    if(loading) return <Loading />

    if(contacts == null)
        return <p>Faça sua pesquisa por termos da conversa.</p>

    if(!contacts.length)
        return <p>Não houve resultados na busca.</p>
    
    const columns:Column<TContact>[] = [
        { id: "phone", label: "Telefonation", render:  c => c.id},
        { id: "name", label: "Nome", render:  c => c.name || ""},
    ]

    return  <>
        <div className='mb-4'>Número de contatos <b>{contacts.length}</b> para a busca <b>{searchTerm}</b></div>
        <div className='table-view' style={{maxHeight: "calc(100vh - 312px)", position: "relative", overflow:"auto"}}>
            <Table columns={columns} data={contacts} />
        </div>
    </>
}